/* =========================================================
   RIODRIP — JS du thème
   ========================================================= */
(function () {
  'use strict';
  var R = window.RioDrip || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var root = (R.routes && R.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';

  /* ---------- Format prix ---------- */
  function formatMoney(cents) {
    var fmt = R.moneyFormat || '{{amount_with_comma_separator}}€';
    function withDelims(n, prec, th, dec) {
      n = (n / 100).toFixed(prec);
      var parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th) + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return withDelims(cents, 2, ',', '.');
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_space_separator': return withDelims(cents, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        default: return withDelims(cents, 2, '.', ',');
      }
    });
  }

  /* ---------- Menu mobile ---------- */
  function toggle(el, open) {
    if (!el) return;
    el.classList.toggle('is-open', open);
    el.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-bz-menu-open]')) toggle($('#bz-mobile-nav'), true);
    if (t.closest('[data-bz-menu-close]')) toggle($('#bz-mobile-nav'), false);
    var mOpen = t.closest('[data-bz-modal-open]');
    if (mOpen) toggle(document.getElementById(mOpen.getAttribute('data-bz-modal-open')), true);
    var mClose = t.closest('[data-bz-modal-close]');
    if (mClose) toggle(mClose.closest('.bz-modal'), false);
    if (t.closest('[data-bz-drawer-close]')) toggle($('#bz-cart-drawer'), false);
    var cartBtn = t.closest('[data-bz-cart-open]');
    if (cartBtn && R.drawer && !document.querySelector('[data-bz-cartpage]')) {
      e.preventDefault();
      toggle($('#bz-cart-drawer'), true);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.bz-drawer.is-open, .bz-modal.is-open, .bz-mobile-nav.is-open').forEach(function (el) { toggle(el, false); });
  });

  /* ---------- Panier ---------- */
  var state = { count: 0 };

  function renderDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-bz-drawer-content]');
    var cur = $('[data-bz-drawer-content]');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
  }
  function setCount(n) {
    state.count = n;
    $$('[data-bz-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
    $$('[data-bz-offer]').forEach(function (el) { el.setAttribute('data-cart-count', n); });
    updateOffer();
  }
  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* Attribut de commande "Cadeau offert" : visible dans l'admin Shopify quand l'offre est atteinte */
  function syncGift(cart) {
    if (!R.offer || !R.offer.enabled) return Promise.resolve(cart);
    var key = R.offer.attrKey;
    var want = cart.item_count >= R.offer.threshold ? R.offer.attrValue : '';
    var have = (cart.attributes && cart.attributes[key]) || '';
    if (want === have) return Promise.resolve(cart);
    var body = { attributes: {} };
    body.attributes[key] = want;
    return fetch(root + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function afterCartChange(sectionsHtml) {
    if (sectionsHtml) renderDrawer(sectionsHtml);
    return getCart().then(syncGift).then(function (cart) { setCount(cart.item_count); return cart; });
  }

  // Ajout au panier AJAX
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-bz-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = $('[data-bz-atc]', form);
    var err = $('[data-bz-error]', form);
    if (err) err.hidden = true;
    btn && btn.setAttribute('disabled', '');
    var fd = new FormData(form);
    Array.from(fd.keys()).filter(function (k) { return k.indexOf('options[') === 0; }).forEach(function (k) { fd.delete(k); });
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Erreur');
        return afterCartChange(res.sections && res.sections['cart-drawer']).then(function () {
          // Re-rendu du tiroir (la barre d'offre dépend de l'attribut / du total)
          return fetch(root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (s) { renderDrawer(s['cart-drawer']); });
        });
      })
      .then(function () {
        var q = $('[data-bz-qty-input]', form); if (q) q.value = 1;
        updateOffer();
        if (R.drawer) toggle($('#bz-cart-drawer'), true); else window.location.href = R.routes.cart;
      })
      .catch(function (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } })
      .finally(function () { btn && btn.removeAttribute('disabled'); });
  });

  // Quantités dans le panier (tiroir + page panier)
  function changeLine(line, qty) {
    document.body.classList.add('is-loading-cart');
    return fetch(root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: 'cart-drawer' })
    }).then(function (r) { return r.json(); })
      .then(function (res) { return afterCartChange(res.sections && res.sections['cart-drawer']); })
      .then(function () {
        if (document.querySelector('[data-bz-cartpage]')) { window.location.reload(); return; }
        return fetch(root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (s) { renderDrawer(s['cart-drawer']); });
      })
      .finally(function () { document.body.classList.remove('is-loading-cart'); });
  }
  document.addEventListener('click', function (e) {
    var line = e.target.closest('.bz-line');
    if (!line) return;
    var idx = parseInt(line.getAttribute('data-line'), 10);
    var input = $('[data-line-input]', line);
    var cur = parseInt(input.value, 10) || 0;
    var act = e.target.closest('[data-action]');
    if (act) { changeLine(idx, act.getAttribute('data-action') === 'plus' ? cur + 1 : Math.max(0, cur - 1)); }
    if (e.target.closest('[data-bz-remove]')) changeLine(idx, 0);
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-line-input]')) return;
    var line = e.target.closest('.bz-line');
    changeLine(parseInt(line.getAttribute('data-line'), 10), Math.max(0, parseInt(e.target.value, 10) || 0));
  });

  /* ---------- Offre 2 + 1 (fiche produit) ---------- */
  function updateOffer() {
    $$('[data-bz-offer]').forEach(function (box) {
      var threshold = parseInt(box.getAttribute('data-threshold'), 10) || 2;
      var inCart = parseInt(box.getAttribute('data-cart-count'), 10) || 0;
      var qInput = $('[data-bz-qty-input]');
      var qty = qInput ? (parseInt(qInput.value, 10) || 1) : 1;
      var total = inCart + qty;
      $$('.bz-tier', box).forEach(function (t) {
        var n = t.getAttribute('data-tier');
        if (n === 'gift') t.classList.toggle('is-on', total >= threshold);
        else t.classList.toggle('is-on', total >= parseInt(n, 10));
      });
      var bar = $('[data-bz-offer-bar]', box);
      if (bar) bar.style.width = Math.min(100, Math.round(total / threshold * 100)) + '%';
      var st = $('[data-bz-offer-status]', box);
      if (!st) return;
      var missing = threshold - total;
      st.classList.toggle('is-unlocked', missing <= 0);
      if (missing <= 0) {
        st.innerHTML = '🎉 3<sup>e</sup> pièce offerte débloquée ! Elle sera ajoutée automatiquement à ta commande.';
      } else if (inCart > 0) {
        st.innerHTML = 'Tu as déjà <b>' + inCart + '</b> pièce' + (inCart > 1 ? 's' : '') + ' au panier. Ajoute encore <b>' + missing + '</b> pièce' + (missing > 1 ? 's' : '') + ' pour débloquer la 3<sup>e</sup> offerte.';
      } else {
        st.innerHTML = 'Passe la quantité à <b>' + threshold + '</b> pour débloquer la 3<sup>e</sup> pièce offerte.';
      }
    });
  }

  /* ---------- Compte à rebours jusqu'à minuit (Paris) ---------- */
  function parisSecondsLeft() {
    try {
      var parts = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).formatToParts(new Date());
      var g = function (t) { var p = parts.filter(function (x) { return x.type === t; })[0]; return p ? parseInt(p.value, 10) % 24 : 0; };
      var h = g('hour'), m = parseInt(parts.filter(function (x) { return x.type === 'minute'; })[0].value, 10), s = parseInt(parts.filter(function (x) { return x.type === 'second'; })[0].value, 10);
      return 86400 - (h * 3600 + m * 60 + s);
    } catch (e) {
      var d = new Date(); return 86400 - (d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds());
    }
  }
  function tick() {
    var left = parisSecondsLeft();
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    $$('[data-bz-countdown]').forEach(function (c) {
      $('[data-h]', c).textContent = pad(Math.floor(left / 3600));
      $('[data-m]', c).textContent = pad(Math.floor(left % 3600 / 60));
      $('[data-s]', c).textContent = pad(left % 60);
    });
  }

  /* ---------- Fiche produit : variantes, galerie, quantité, sticky ---------- */
  function initProduct() {
    var wrap = $('[data-bz-product]');
    if (!wrap) return;
    var form = $('[data-bz-product-form]', wrap);
    var dataEl = $('[data-bz-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var mainImg = $('.bz-gallery__main img', wrap);

    function setMain(src, mediaId) {
      if (mainImg && src) { mainImg.removeAttribute('srcset'); mainImg.src = src; }
      $$('[data-bz-thumb]', wrap).forEach(function (b) { b.classList.toggle('is-active', String(b.getAttribute('data-media-id')) === String(mediaId)); });
    }
    $$('[data-bz-thumb]', wrap).forEach(function (b) {
      b.addEventListener('click', function () { setMain(b.getAttribute('data-src'), b.getAttribute('data-media-id')); });
    });

    function currentOptions() {
      return $$('[data-bz-option]', form).map(function (fs) {
        var c = $('input:checked', fs); return c ? c.value : null;
      });
    }
    function onVariantChange() {
      var opts = currentOptions();
      $$('[data-bz-option]', form).forEach(function (fs, i) { var l = $('[data-bz-option-label]', fs); if (l) l.textContent = opts[i]; });
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); })[0];
      var btn = $('[data-bz-atc]', form), lbl = $('[data-bz-atc-label]', form);
      if (!v) { btn.setAttribute('disabled', ''); lbl.textContent = 'Indisponible'; return; }
      $('[data-bz-variant-id]', form).value = v.id;
      $('[data-bz-price]').textContent = formatMoney(v.price);
      var sp = $('[data-bz-sticky-price]'); if (sp) sp.textContent = formatMoney(v.price);
      var ap = $('[data-bz-atc-price]'); if (ap) ap.textContent = formatMoney(v.price);
      var ac = $('[data-bz-atc-compare]');
      if (ac) { var sl = v.compare_at_price && v.compare_at_price > v.price; ac.hidden = !sl; if (sl) ac.textContent = formatMoney(v.compare_at_price); }
      var cmp = $('[data-bz-compare]'), save = $('[data-bz-save]'), badge = $('[data-bz-badge]');
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      if (cmp) { cmp.hidden = !sale; if (sale) cmp.textContent = formatMoney(v.compare_at_price); }
      if (save) { save.hidden = !sale; if (sale) save.textContent = 'Économise ' + formatMoney(v.compare_at_price - v.price); }
      if (badge) { badge.hidden = !sale; if (sale) badge.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
      if (v.available) { btn.removeAttribute('disabled'); lbl.textContent = 'Ajouter au panier'; }
      else { btn.setAttribute('disabled', ''); lbl.textContent = 'Épuisé'; }
      if (v.featured_media) {
        var th = $('[data-bz-thumb][data-media-id="' + v.featured_media.id + '"]', wrap);
        setMain(th ? th.getAttribute('data-src') : v.featured_media.preview_image.src, v.featured_media.id);
      }
      // Pilules indisponibles (sur la dernière option, selon les autres)
      var fsets = $$('[data-bz-option]', form);
      if (fsets.length) {
        var last = fsets.length - 1;
        $$('input', fsets[last]).forEach(function (inp) {
          var test = opts.slice(); test[last] = inp.value;
          var ok = variants.some(function (x) { return x.available && x.options.every(function (o, i) { return o === test[i]; }); });
          inp.parentNode.classList.toggle('is-unavailable', !ok);
        });
      }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    form.addEventListener('change', function (e) { if (e.target.name && e.target.name.indexOf('options[') === 0) onVariantChange(); });
    if (variants.length > 1) onVariantChange();

    var qty = $('[data-bz-qty]', form);
    if (qty) {
      var input = $('input', qty);
      qty.addEventListener('click', function (e) {
        var a = e.target.closest('[data-action]'); if (!a) return;
        var v = parseInt(input.value, 10) || 1;
        input.value = a.getAttribute('data-action') === 'plus' ? v + 1 : Math.max(1, v - 1);
        updateOffer();
      });
      input.addEventListener('input', updateOffer);
    }

    var sticky = $('[data-bz-sticky]'), atc = $('[data-bz-atc]', form);
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }).observe(atc);
      $('[data-bz-sticky-btn]').addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else atc.click();
      });
    }
  }


  /* ---------- Timeline de livraison (jours ouvrés) ---------- */
  function addBusinessDays(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; }
    return r;
  }
  function fmtDay(d) {
    try { return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }); }
    catch (e) { return d.getDate() + '/' + (d.getMonth() + 1); }
  }
  function initTimeline() {
    $$('[data-bz-timeline]').forEach(function (tl) {
      var min = parseInt(tl.getAttribute('data-min'), 10) || 3;
      var max = Math.max(min, parseInt(tl.getAttribute('data-max'), 10) || min);
      var now = new Date();
      // Commande le week-end → préparation le lundi
      var start = new Date(now.getTime());
      if (start.getDay() === 6 || start.getDay() === 0) start = addBusinessDays(start, 1);
      var d2 = addBusinessDays(start, 1);
      var dMin = addBusinessDays(start, min - 1);
      var dMax = addBusinessDays(start, max - 1);
      var sameDay = start.toDateString() === now.toDateString();
      var e1 = $('[data-bz-tl-d1]', tl); if (e1) e1.textContent = sameDay ? "Aujourd'hui" : fmtDay(start);
      var e2 = $('[data-bz-tl-d2]', tl); if (e2) e2.textContent = fmtDay(d2);
      var e3 = $('[data-bz-tl-d3]', tl); if (e3) e3.textContent = min === max ? fmtDay(dMax) : fmtDay(dMin) + ' – ' + fmtDay(dMax);
      var rg = $('[data-bz-tl-range]', tl); if (rg) rg.textContent = min === max ? 'le ' + fmtDay(dMax) : 'entre le ' + fmtDay(dMin) + ' et le ' + fmtDay(dMax);
    });
  }

  /* ---------- Vidéos TikTok ---------- */
  function initVideos() {
    var vids = $$('.bz-video video');
    if (!vids.length) return;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target, fig = v.closest('.bz-video');
        if (en.isIntersecting) { v.muted = v.muted !== false ? true : v.muted; var p = v.play(); if (p && p.then) p.then(function () { fig.classList.add('is-playing'); }).catch(function () {}); }
        else { v.pause(); fig.classList.remove('is-playing'); }
      });
    }, { threshold: 0.6 }) : null;
    vids.forEach(function (v) {
      v.muted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.loop = true;
      if (io) io.observe(v);
    });
    document.addEventListener('click', function (e) {
      var frame = e.target.closest('.bz-video__frame');
      if (!frame) return;
      var v = $('video', frame); if (!v) return;
      var fig = frame.closest('.bz-video');
      var btn = $('[data-bz-sound]', frame);
      if (e.target.closest('[data-bz-sound]') || !v.paused) {
        // Un seul son à la fois
        $$('.bz-video video').forEach(function (o) { if (o !== v) { o.muted = true; var b = $('[data-bz-sound]', o.parentNode); if (b) b.textContent = '🔇'; } });
        v.muted = !v.muted; if (btn) btn.textContent = v.muted ? '🔇' : '🔊';
        if (v.paused) v.play();
      } else {
        v.play(); fig.classList.add('is-playing');
      }
    });
  }

  /* ---------- Recommandations produit ---------- */
  function initReco() {
    $$('[data-bz-reco]').forEach(function (el) {
      if (el.children.length) return;
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        var fresh = d.querySelector('[data-bz-reco]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    });
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initProduct();
    initTimeline();
    initVideos();
    initReco();
    updateOffer();
    if ($('[data-bz-countdown]')) { tick(); setInterval(tick, 1000); }
    // Vérifie l'attribut cadeau au chargement (ex. panier modifié ailleurs)
    getCart().then(syncGift).then(function (c) { setCount(c.item_count); }).catch(function () {});
  });
})();
